<template>
  <div>
    <v-card flat>
      <v-tooltip top>
        <template slot="activator">
          <v-btn
            fixed
            dark
            fab
            bottom
            right
            color="lime"
            class="mr-3 mb-3"
            @click.native="fab_button"
            :disabled="disabled"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Click to save the change you have made</span>
      </v-tooltip>

      <v-card-title>
        <v-toolbar dark color="lime">
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <v-toolbar-title
            >JND CONFERENCE 2024 ABSTRACT REVIEWERS ASSIGNMENT.</v-toolbar-title
          >
        </v-toolbar>
      </v-card-title>
      <v-alert :value="error_alert_value" type="error"
        >Please fix all errors before saving. Ensure that the required input on
        the form is filled correctly</v-alert
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-progress-linear
              :indeterminate="true"
              color="lime"
              v-if="sending"
            ></v-progress-linear>
            <v-flex xs12 sm12 md4>
              <v-text-field
                v-model="model.reviewer_name"
                :error-messages="errors.reviewer_name"
                label="Reviewer Name"
                color="lime"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <v-text-field
                v-model="model.phone_number"
                :error-messages="errors.phone_number"
                label="Phone number"
                color="lime"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <v-text-field
                v-model="model.email"
                :error-messages="errors.email"
                label="Email"
                color="lime"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                v-model="model.article_name"
                :error-messages="errors.article_name"
                label="Article Name"
                color="lime"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                v-model="model.article_number"
                :error-messages="errors.article_number"
                label="Article Number"
                color="lime"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                v-model="model.authors"
                :error-messages="errors.authors"
                label="Authors"
                color="lime"
                prepend-icon="assessment"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                v-model="model.keywords"
                :error-messages="errors.keywords"
                label="Keywords"
                color="lime"
                prepend-icon="assessment"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-autocomplete
                item-text="name"
                item-value="id"
                :items="subthemes"
                v-model="model.subtheme"
                label="Sub-theme"
                color="lime"
                hint="select a conference sub-theme"
                :menu-props="{ maxHeight: '400' }"
                persistent-hint
                :error-messages="errors.subtheme"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea
                label="Abstract"
                v-model="model.abstract"
                :error-messages="errors.abstract"
                color="lime"
                rows="20"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm12 md12 class="mt-5">
              <h3 class="font-weight-light">
                Set your status for this Abstract
              </h3>
              <v-radio-group v-model="model.abstract_status">
                <v-radio
                  label="Approve for poster"
                  value="Approve for poster"
                  color="lime"
                ></v-radio>
                <v-radio
                  label="Approve for Oral Presentation"
                  value="Approve for oral Presentation"
                  color="lime"
                ></v-radio>
                <v-radio label="Reject" value="reject" color="lime"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea
                label="Comments"
                v-model="model.comment"
                :error-messages="errors.comment"
                color="lime"
                rows="10"
                outline
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :multi-line="mode"
      :right="x"
      :top="y"
      :timeout="timeout"
    >
      {{ snackbar_text }}
      <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import swal from "sweetalert2"
import {
  jndArticleAssessmentEditOneUrl,
  jndArticleAssessmentEditUrl
} from "@/config"
export default {
  data() {
    return {
      menu1: false,
      dialog_add: false,
      show_container_can: false,
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      timeout: 6000,
      menu: false,
      disabled: false,
      model: {},
      downloaded: false,
      error_alert_value: false,
      errors: {},
      /*subthemes: [
        {
          id: "Food Systems in Sustainable Development",
          name: "Food Systems in Sustainable Development"
        },
        {
          id: "Maternal, Infant and Young Child Nutrition and Health Policy",
          name: "Maternal, Infant and Young Child Nutrition and Health Policy"
        },
        {
          id: "Insect-based Diet/Entomophagy, Food Security and Policy",
          name: "Insect-based Diet/Entomophagy, Food Security and Policy"
        },
        {
          id: "Waste Management, Diet and Policy",
          name: "Waste Management, Diet and Policy"
        },
        {
          id: "Food systems, Diets and Healthy Lifestyle",
          name: "Food systems, Diets and Healthy Lifestyle"
        },
        {
          id: "Technological Approaches in The Food Systems",
          name: "Technological Approaches in The Food Systems"
        },
        {
          id: "Agricultural Practices and Food Systems Value Chain",
          name: "Agricultural Practices and Food Systems Value Chain"
        },
        {
          id: "Indigenous Knowledge and Plant-Based Diet",
          name: "Indigenous Knowledge and Plant-Based Diet"
        }
      ],*/
      subthemes: [
        {
          id: "Geo-political conflicts and Food Systems",
          name: "Geo-political conflicts and Food Systems"
        },
        {
          id: "Micro-Biota and Early Stage Malnutrition",
          name: "Micro-Biota and Early Stage Malnutrition"
        },
        {
          id: "Climatic Change and Food Systems Value Chain",
          name: "Climatic Change and Food Systems Value Chain"
        },
        {
          id: "Multi-sectoral and Multi-disciplinary collaborations",
          name: "Multi-sectoral and Multi-disciplinary collaborations"
        },
        {
          id: "Zoonotic diseases, Food and Human Health",
          name: "Zoonotic diseases, Food and Human Health"
        },
        {
          id: "Micronutrient Food Processing, commercialization and Health.",
          name: "Micronutrient Food Processing, commercialization and Health."
        },
        {
          id:
            "One Health, Food Systems and Anthropology (Culture, Religious Doctrines)",
          name:
            "One Health, Food Systems and Anthropology (Culture, Religious Doctrines)"
        }
      ],
      sending: false
    }
  },
  beforeMount() {
    if (this.$route.params.id != "") {
      this.fetchData()
      this.downloaded = true
    } else {
      swal({
        title: "Unauthorized",
        text: "You are not authorized to use this service",
        type: "warning",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
    }
  },
  methods: {
    fab_button() {
      var vm = this
      swal({
        title: "Confirm",
        text: "Do you want to submit the form",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#CDDC39",
        cancelButtonColor: "#F44336",
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          vm.saveEdit()
        } else if (
          // Read more about handling dismissals
          result.dismiss === "cancel"
        ) {
          swal({
            title: "Cancelled",
            text: "form was not submitted",
            type: "error",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
        }
      })
    },
    fetchData() {
      var vm = this
      vm.submit_type = false
      vm.snackbar_text = "Please stand by as background data is loading."
      vm.snackbar = true
      vm.x = "right"
      vm.y = "top"
      vm.mode = "multi-line"
      vm.timeout = 8000
      vm.loaded = true
      var data = {
        id: vm.$route.params.id
      }

      const options = {
        method: "POST",
        data: data,
        url: jndArticleAssessmentEditOneUrl
      }
      vm.downloaded = true
      axios(options)
        .then(function(response) {
          if (response.data) {
            vm.downloaded = false
            Vue.set(vm.$data, "model", response.data)
            vm.loaded = false
            vm.submit_type = true
            vm.snackbar_text = "Background data successfully loaded."
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.timeout = 3000
          }
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    saveEdit() {
      var vm = this
      vm.sending = true
      vm.disabled = true
      vm.downloaded = true
      vm.error_alert_value = false

      var data = {
        id: vm.$route.params.id,
        article_name: vm.model.article_name,
        reviewer_name: vm.model.reviewer_name,
        article_number: vm.model.article_number,
        keywords: vm.model.keywords,
        abstract: vm.model.abstract,
        phone_number: vm.model.phone_number,
        email: vm.model.email,
        authors: vm.model.authors,
        subtheme: vm.model.subtheme,
        comment: vm.model.comment,
        abstract_status: vm.model.abstract_status
      }

      const options = {
        method: "POST",
        data: data,
        url: jndArticleAssessmentEditUrl
      }
      vm.downloaded = true
      axios(options)
        .then(function(response) {
          if (response.data.success) {
            swal({
              title: "Submitted",
              text: "Submission is successful",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push("/jnd-article/conference/2024/reviewers")
          }
          if (response.data.failed) {
            swal({
              title: "Duplicate",
              text: "This article has already been assigned to a reviewer.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          if (response.data.empty) {
            vm.error_alert_value = true
            swal({
              title: "Validation",
              text: "Fill in all fields.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          vm.sending = false
          vm.disabled = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error)
          if (error.response.data) {
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.error_alert_value = true
            vm.downloaded = false
          }
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/jnd-article-assessment-edit.vue